import * as React from 'react';
import { RouteComponentProps, withRouter, Link } from 'react-router-dom';
import { Redirect } from 'react-router';
import axios from '../../helpers/axios';
import { Grid, Card, CardContent, CardHeader, IconButton, Button, Avatar, Menu, MenuItem, Typography, FormControl, OutlinedInput, TextField, Select, InputLabel, Box, Chip, Checkbox, ListItemText, Backdrop, CircularProgress } from '@mui/material';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { withTranslation, WithTranslation } from 'react-i18next';
import ReportsHeader from './ReportsHeader';
import { DataGrid, GridRowParams, GridActionsCellItem, GridCellParams } from '@mui/x-data-grid';
import { EditOutlined, Add, Security as SecurityIcon, FileCopy as FileCopyIcon, KeyboardArrowLeftRounded, MoreHorizOutlined } from '@mui/icons-material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import { formatDate } from '../../helpers/custom';

export interface IProps {
    user: {
        id: number;
        name: string;
        email: string;
        role: string;
        is_active: boolean;
        selectedHierarchyIds?: any[];
        selectedHierarchies?: any[];
    };
}

export interface IState {
    showLoader: boolean;
    anchorEl: any;
    cities: any[];
    city: any;
    fromDate?: string | null;
    toDate?: string | null;
    report_type: string;
    personName: any[];
    pageSize: any;
    pickupReports: any;
    filter: any;
    reportTypes: any[];
    reportType: any;
}

class CityReport extends React.Component<RouteComponentProps<any> & IProps & WithTranslation, IState> {
    constructor(props: RouteComponentProps & IProps & WithTranslation) {
        super(props);
        this.state = {
            showLoader: false,
            anchorEl: null,
            cities: [],
            city: "",
            fromDate: null,
            toDate: null,
            report_type: '',
            personName: [],
            pageSize: 5,
            pickupReports: [],
            filter: '',
            reportTypes: [
                {
                    title: 'Kg',
                    url: 'report/hierarchy/download/kg/',
                    show: true
                },
                {
                    title: 'Price',
                    url: 'report/hierarchy/download/price/',
                    show: true
                },
                {
                    title: 'MNH Charges',
                    url: 'report/hierarchy/download/mnh/',
                    show: true
                },
                {
                    title: 'Bag',
                    url: 'report/hierarchy/download/bags/',
                    show: true
                },
                {
                    title: 'Bad Bag',
                    url: 'report/hierarchy/download/bad-bags/',
                    show: true
                },
                {
                    title: 'P3 Users',
                    url: 'report/hierarchy/download/p3-users/',
                    show: this.props.user.email && this.props.user.email.endsWith('@bintix.com')
                }
            ],
            reportType: ""
        }
    }
    public componentDidMount(): void {
        // axios.get(`routes`).then(response => {
        //     this.setState({ routes: response.data.data })
        // });
        this.fetchAccessibleHierarchiesList();
    }

    public fetchAccessibleHierarchiesList() {
        axios.get(`accessibleHierarchiesList`).then(response => {
            let cities: any = [];
            if (response.data.success) {
                const selectedHierarchyIds = this.props.user.selectedHierarchyIds || [];
                cities = response.data.data.filter((city: any) => selectedHierarchyIds.includes(city.id));
            }
            this.setState({ cities: cities });
        })
    }

    public render() {
        if (!localStorage.getItem('token')) {
            return (
                <Redirect to="/login" />
            );
        }
        const { t } = this.props;
        const open = Boolean(this.state.anchorEl);

        const generateFileName = ((type: string, name: string) => {
            return type + '_Report_' + name + '.csv';
        })

        const handleDownloadReport = (() => {
            this.setState({ showLoader: true });
            let url = this.state.reportType.url + this.state.city.id;
            if(this.state.reportType && this.state.reportType.title != "P3 Users"){
                url += '/' + this.state.fromDate + '/' + this.state.toDate;
            }
            axios.get(url).then((response: any) => {
                this.setState({ showLoader: false });
                let fileName = generateFileName(this.state.reportType.title, this.state.city.name);
                const blob = new Blob([response.data], { type: response.headers['content-type'] });

                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = fileName;

                document.body.appendChild(link);
                link.click();

                document.body.removeChild(link);
            }).catch((error) => {
                this.setState({ showLoader: false });
                console.log("error logs here", error);
                toast.error(((error.response.data.message) ? error.response.data.message : "Something went wrong"), {
                    position: "top-right",
                    autoClose: false,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
            });
        });

        const MenuProps = {
            PaperProps: {
                style: {
                    maxHeight: 48 * 4.5 + 8,
                    width: 250,
                },
            },
        };

        const names = [
            'Kg',
            'Price',
            'Bag',
            'Bad Bag'
        ];


        const columns: any = [

            {
                headerName: "Customer Name",
                field: "customer_name",
                width: 250
            },
            {
                headerName: "Mobile",
                field: "mobile",
                width: 150
            },
            {
                headerName: "H.No.",
                field: "house_number",
                width: 200
            },
            {
                headerName: "Total kg",
                field: "total_kgs",
                width: 200
            },
            {
                headerName: "Pending Payment",
                field: "pending_payment",
                width: 120
            },

        ];

        return (
            <div>
                <Backdrop
                    sx={{ zIndex: (theme) => theme.zIndex.drawer + 1000 }}
                    open={this.state.showLoader}
                // onClick={() => this.setState({ showLoader: false })}
                >
                    <CircularProgress className='customLoader' />
                </Backdrop>
                <ToastContainer
                    position="top-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={true}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                />
                <ReportsHeader user={this.props.user}/>
                <Grid container spacing={2}>
                    <Grid item md={12} xs={12} className="mt-3">
                        <Card>
                            <CardContent className="text-left">
                                <Grid container spacing={2}>
                                    <Grid item md={12} xs={12}>
                                        <Grid container spacing={2}>
                                            <Grid item md={3} xs={12}>
                                                <FormControl fullWidth={true}>
                                                    <InputLabel id="community-label">City *</InputLabel>
                                                    <Select
                                                        labelId="community-label"
                                                        value={this.state.city}
                                                        onChange={(e: any) => this.setState({ city: e.target.value })}
                                                        displayEmpty
                                                        label="City *"
                                                        fullWidth={true}
                                                    >
                                                        {
                                                            this.state.cities.map((city) => {
                                                                return <MenuItem key={city.id} value={city}>{city.name}</MenuItem>
                                                            })
                                                        }
                                                    </Select>
                                                </FormControl>
                                            </Grid>
                                            <Grid item md={9} xs={12}>
                                                <Grid container spacing={2}>
                                                    <Grid item md={3} xs={6}>
                                                        <FormControl fullWidth={true}>
                                                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                                <DatePicker
                                                                    renderInput={(props) => <TextField {...props} />}
                                                                    label="From Date *"
                                                                    views={['year', 'month', 'day']}
                                                                    value={this.state.fromDate}
                                                                    onChange={(newValue: any) => {
                                                                        this.setState({ fromDate: formatDate(newValue, 'Y-m-d') });
                                                                    }}
                                                                    inputFormat="yyyy-MM-dd"
                                                                    mask="____-__-__"
                                                                    disabled={(this.state.reportType && this.state.reportType.title == "P3 Users")}
                                                                />
                                                            </LocalizationProvider>
                                                        </FormControl>
                                                    </Grid>
                                                    <Grid item md={3} xs={6}>
                                                        <FormControl fullWidth={true}>
                                                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                                <DatePicker
                                                                    renderInput={(props) => <TextField {...props} />}
                                                                    label="To Date *"
                                                                    views={['year', 'month', 'day']}
                                                                    value={this.state.toDate}
                                                                    onChange={(newValue: any) => {
                                                                        this.setState({ toDate: formatDate(newValue, 'Y-m-d') });
                                                                    }}
                                                                    inputFormat="yyyy-MM-dd"
                                                                    mask="____-__-__"
                                                                    disabled={(this.state.reportType && this.state.reportType.title == "P3 Users")}
                                                                />
                                                            </LocalizationProvider>
                                                        </FormControl>
                                                    </Grid>
                                                    <Grid item md={3} xs={12}>
                                                        {/* <FormControl fullWidth={true}>
                                                            <InputLabel id="report-type-label">Report Type *</InputLabel>
                                                            <Select
                                                                labelId="report-type-label"
                                                                value={this.state.report_type}
                                                                onChange={(e) => this.setState({ report_type: e.target.value })}
                                                                displayEmpty
                                                                label="Report Type *"
                                                                fullWidth={true}
                                                            >
                                                                <MenuItem key={'kg'} value={'kg'}>{t("Kg")}</MenuItem>
                                                                <MenuItem key={'price'} value={'price'}>{t("Price")}</MenuItem>
                                                                <MenuItem key={'bag'} value={'bag'}>{t("Bag")}</MenuItem>
                                                                <MenuItem key={'bad_bag'} value={'bad_bag'}>{t("Bad Bag")}</MenuItem>
                                                            </Select>
                                                        </FormControl> */}
                                                        {/* <FormControl fullWidth={true}>
                                                            <InputLabel id="demo-multiple-checkbox-label">Report Type</InputLabel>
                                                            <Select
                                                                labelId="demo-multiple-checkbox-label"
                                                                id="demo-multiple-checkbox"
                                                                multiple
                                                                value={this.state.personName}
                                                                onChange={(event: any) => handleChange(event)}
                                                                input={<OutlinedInput label="Tag" />}
                                                                renderValue={(selected: any) => (
                                                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                                                        {selected.map((value: any) => (
                                                                            <Chip key={value} label={value} />
                                                                        ))}
                                                                    </Box>
                                                                )}
                                                                MenuProps={MenuProps}
                                                            >
                                                                {names.map((name) => (
                                                                    <MenuItem key={name} value={name}>
                                                                        <Checkbox checked={this.state.personName.indexOf(name) > -1} />
                                                                        <ListItemText primary={name} />
                                                                    </MenuItem>
                                                                ))}
                                                            </Select>
                                                        </FormControl> */}
                                                        <FormControl fullWidth>
                                                            <InputLabel id="demo-simple-select-label">Report Type</InputLabel>
                                                            <Select
                                                                labelId="demo-simple-select-label"
                                                                id="demo-simple-select"
                                                                value={this.state.reportType}
                                                                label="Report Type"
                                                                onChange={(e: any) => this.setState({ reportType: e.target.value })}
                                                            >
                                                                {
                                                                    this.state.reportTypes.map((reportType: any, reportTypeKey: number) => {
                                                                        if(reportType.show){
                                                                            return <MenuItem key={'reportTyp' + reportTypeKey} value={reportType}>{reportType.title}</MenuItem>
                                                                        }
                                                                    })
                                                                }
                                                            </Select>
                                                        </FormControl>
                                                    </Grid>
                                                    <Grid item md={3} xs={12}>
                                                        <Button size='large' fullWidth={true} variant='contained' sx={{ outline: 'none !important', marginTop: '6px' }} disabled={!this.state.city || ((this.state.reportType && this.state.reportType.title != "P3 Users") && (!this.state.fromDate || !this.state.toDate)) || !this.state.reportType} onClick={() => handleDownloadReport()}>{t("Download")}</Button>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            </div>
        )
    }
}

export default withRouter(withTranslation()(CityReport))
